export default __webpack_public_path__ + "static/media/pen-icon.06deb680.svg";